import * as React from "react";

function SvgConnectIcon(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={18.557} height={14.981} {...props}>
        <g data-name="Group 11519" fill="#3c4252">
          <path
            data-name="Path 43708"
            d="M8.089 10.822a3.326 3.326 0 01-3.219-2.5l-.047-.181H.001v-1.3h4.822l.047-.181a3.325 3.325 0 013.221-2.5 3.276 3.276 0 01.56.048 3.327 3.327 0 01-.558 6.607zm0-5.355a2.028 2.028 0 101.433.594 2.015 2.015 0 00-1.433-.594z"
          />
          <path
            data-name="Path 43709"
            d="M7.796 14.976a7.474 7.474 0 01-4.833-2.018l.919-.92a6.192 6.192 0 100-9.092l-.919-.919a7.489 7.489 0 0112.564 4.6l.024.214h3.005v1.3h-3l-.025.213a7.494 7.494 0 01-7.442 6.623 3.57 3.57 0 01-.293-.001z"
          />
        </g>
      </svg>
    </span>
  );
}

export default SvgConnectIcon;
